var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('notifications',{attrs:{"position":"top right","width":"200px"}}),_c('version-dialog',{attrs:{"show":_vm.hashChanged},on:{"submit":_vm.reloadApp}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }